module.exports = __webpack_public_path__ + "static/alexwork5-580abd93f18faff5d1cc247764a9c079.jpg";